<app-page-container>
  <div class="opcoes">
    <div class="titulo">
      <span>Demonstrativo Financeiro</span>
    </div>


    <form [formGroup]="filtraForm" *ngIf="autorizacoes.listarDemonstrativosFinanceiros" class="form-filtro-financeiro">
      <div class="mb-4">
        <label class="label__style mb-2">Pesquisar</label>
        <input id="FiltroPesquisar" name="FiltroPesquisar" class="form-control mr-sm-2 my-sm-0" type="search"
          aria-label="Pesquisar" formControlName="FiltroPesquisar" placeholder="Pesquisar...">
      </div>
      <button class="btn btn-primary mt-2" type="button" (click)="getFatura()">Buscar</button>
    </form>
    <div class="mobile">
      <div class="mobile-table">
        <app-item-financeiro-mobile *ngFor="let fatura of faturas.registros"
          [financeiro]="fatura"></app-item-financeiro-mobile>
      </div>
    </div>
    <div class="desktop">
      <app-tabela
        [cabecalhos]="['ID', 'Data', 'Contrato', 'Tipo de Contrato', 'Período', 'Unidade', 'Fatura', 'Boleto', 'Status']"
        [items]="faturas.registros" [colunasOcultas]="['Contrato']"
        [condicoesColunas]="[{ columnName: 'Contrato', condition: autorizacoes.exibirDetalhesDemonstrativoFinanceiro }]">
        <tr *ngFor="let fatura of faturas.registros">
          <td><a class="is-link" *ngIf="fatura.codContrato && fatura.mesAnoFatura && fatura.codFatura"
              [routerLink]="['/demonstrativo-financeiro', fatura.codContrato, fatura.mesAnoFatura, fatura.codFatura]">{{fatura.codFatura
              ||
              'Sem dados'}}</a>
            <ng-container *ngIf="!fatura.codContrato || !fatura.mesAnoFatura">{{fatura.codFatura
              ||
              'Sem dados'}}</ng-container>
          </td>
          <td>{{(fatura.dataFatura | date: 'dd/MM/yyyy') || 'Sem dados' }}</td>
          <td class="visualizar" *ngIf="autorizacoes.exibirDetalhesDemonstrativoFinanceiro">
            {{fatura.codContrato || "Sem dados"}}
          </td>
          <td>{{fatura.classificacaoContrato || 'Sem dados'}}</td>
          <td *ngIf="fatura.inicioPeriodoFatura || fatura.fimPeriodoFatura">{{fatura.inicioPeriodoFatura | date:
            'dd/MM/yyyy'}} à {{fatura.fimPeriodoFatura | date: 'dd/MM/yyyy'}}</td>
          <td *ngIf="!fatura.inicioPeriodoFatura || !fatura.fimPeriodoFatura">Sem dados</td>
          <div *ngIf="environment.company === 'apnetworks'; then apnetworksCliente else kmDoBrasilCliente"></div>
          <ng-template #apnetworksCliente>
            <td>{{fatura.nomeCliente || fatura.nomeFantasiaCliente || 'Sem dados'}}</td>
          </ng-template>
          <ng-template #kmDoBrasilCliente>
            <td>{{fatura.nomeFantasiaCliente || fatura.nomeCliente || 'Sem dados'}}</td>
          </ng-template>
          <td class="visualizar" [ngClass]="{'visualizar-disabled': !autorizacoes.listarDemonstrativosFinanceiros}">
            <button (click)="visualizarFatura(modalVisualizarFatura, fatura.codFatura)"
              [disabled]="!autorizacoes.listarDemonstrativosFinanceiros">Visualizar</button>
          </td>
          <td class="visualizar" [ngClass]="{'visualizar-disabled': !autorizacoes.listarDemonstrativosFinanceiros}">
            <button (click)="visualizarBoleto(modalVisualizarBoleto, fatura)"
              [disabled]="!autorizacoes.listarDemonstrativosFinanceiros">Visualizar</button>
          </td>
          <ng-container [ngSwitch]="true">
            <td *ngSwitchCase="fatura.pagoFatura" class="closed__style">Fechado</td>
            <td *ngSwitchDefault class="open__style">Aberto</td>
          </ng-container>
        </tr>
      </app-tabela>
    </div>
  </div>
  <app-paginacao nomeDaLista="Demonstrativos" [(dados)]="faturas" (dadosChange)="getFatura()"
    *ngIf="this.faturas.registros.length !== 0"></app-paginacao>
</app-page-container>

<ng-template #retornoOSNA>Não há registros.</ng-template>
<ng-template #retornoNOF>Sem dados</ng-template>

<ng-template #modalVisualizarFatura>
  <app-recibo></app-recibo>
  <!-- <app-visualizar-pdf [dataBase64]="faturaBase64" (closeModal)="closeModal()"></app-visualizar-pdf> -->
</ng-template>

<ng-template #modalVisualizarBoleto>
  <app-visualizar-pdf [dataBase64]="boletoBase64" [nomeArquivo]="nomeArquivoBoleto"
    (closeModal)="closeModal()"></app-visualizar-pdf>
</ng-template>